import React, { useEffect, useState } from 'react'
import Icon, { IconType } from '@bt-react/components/Icon'
import Modal from '@bt-react/components/Modal'
import Button from '@bt-react/components/Button'
import useInterval from '@bt-react/libs/useInterval'
import style from './ReconnectionModal.module.scss'
import differenceInSeconds from 'date-fns/differenceInSeconds'
import { addEntry } from '../../lib/audit'

interface ReconnectionModalProps {
  // The time of the Twilio connection error as an ISO string
  twilioConnectionError: string
  reconnectRoom: () => void
  connectionStatus: string
  user?: any
  focused: boolean
}

const CONNECTION_ERROR_TAB_TITLE = '(!) No connection'

const ReconnectionModal: React.FC<ReconnectionModalProps> = props => {

  const [ secondsPassed, setSecondsPassed ] = useState(differenceInSeconds(Date.now(), new Date(props.twilioConnectionError)))

  useEffect(() => {
    if (props.user) {
      const { firstName, lastName, externalIdV2} = props.user
      if (props.twilioConnectionError === null) {
        addEntry('PresenterService', 'ReconnectionModalDisplayedNoTwilError', `${firstName} ${lastName} reconnection modal displayed - user_id:${externalIdV2}`, 'info', externalIdV2)

      } else {
        addEntry('PresenterService', 'ReconnectionModalDisplayed', `${firstName} ${lastName} reconnection modal displayed - user_id:${externalIdV2}`, 'info', externalIdV2)
      }
    }

  }, [props.user, props.twilioConnectionError])

  useEffect(() => {

    
    const favico = document.querySelector("link[rel~='icon']") as HTMLLinkElement

    if (props.connectionStatus === 'disconnected' && !props.focused) {
      
      //Using base64 instead of an actuall href because the browser clears the cache after a while and if the user is offline switching between the two image hrefs will cause the favicon to be empty because the remote image cannot be fetched.
      favico.href = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAJPUExURQAAAFWqAGfOAGfMAGbMAGbMAGC/AGbLAGbMAID/AGbMAGbMAGbMAH2uALldAOImAPcLAOUjAL1YAH+qAGjJALheAP0DAP8AAP4CAL9VAGvGAM9AANY2ALdgAMJSAHyvAIKnAGXMAGTLAGPLAMFTAHjSHp3eW7Dle7PlgLPlf6XhaI7ZQ+AuBegeAJHaSOT20v7//f////n99fwVEvkIAHzTJOb31vj99PD65/D65vP77Pv++f8WFqfibOL1zpLbSX3UJ4LVLpTbTL/qlfw1Mr7pkqXhamLLAGbMA8tnIcHqmP3+/JjdVHmwAP0EAYOmALlfAmXIAN9FG9c1AInUN/tzbv8EBIfXN/f88v/Z2exsUuMnAfgKAICpAJndVv3++8fsoWfMAWjMBMTrnpLbSvT77er43HzTJpfdVGbMAo7ZQuf31vz++6vjc/3//KThZ3XRGXjSHbrojPH6523ODfL76ev43ev43u/65fr997XmhPv++MXsn3/UKv7//srtp6/kerHlfLDlfLLlftHws+j32ZXcTmbMAZfcVGHKAGrNBoLVL8LrmWnNB63kdvr99uP20HrTImnNCMLrmrbnhoPWMvH66OX21GrNCNPwt/n99IzZQLnoiqHgYsTrnZndVXDPEd70yPb874fXNpXcT970yXHQEnfSHdvzw////qHgY3zTJdDvsN30x3XRG6zjdNrzwYXWNHTRF4bXNub31ez534zZP4HVLez54PL76uf31+T20Y/aRJzeW+754nvTJIHVLqzjdb7pk5jdU3rTIUivET8AAAAMdFJOUwADPqTl/Ahx5gL35OUEtOcAAAABYktHRDHZ2x1yAAAAB3RJTUUH6AMZFC837fzHRAAAAktJREFUSMeVlmdXE0EUhocUQhk1oBKMdWYR7PpGUVCxRQWJvfeKBYKKUcEaxYYFY8HexYLYe4m9/DCjkGRnczK7+3zc8z5nZ+7s3TuEkBSL1WanuthtVksKiZDqSJMnO3Ts5HRmZXemNM2RSki6I0Ma79I1x/Wf3G5umuFIJxabPN/dFaOHm9osxCpfT0+Xil6UWkmmNN87Ry3k9qGZRKwP42oULrzA5cqjdiLm++YX9IvSv2DAwEGiMJhSQWBDhg6DGs9wURghCqxwJDCqqDjK6DEYKxV4CTBu/IQYEyd5J0uXxKYAU0s5i8KVsmnaTYtCOXzTFaEKM2YKZZ2lK9DZmoPTFebMjefnuQ0IfP6Che3ryfuX1xcWLV6ydJlzeVb2irYHeoKychVWr1E90BPWrgNKuHGBV6zHho1MImwqZXF4ZZUf1ZvVea2wZWvNthiFVYHt8JXvkAnYWVsXY5cH2L1HzCcIWvbu2y8VggcO1kc5dDhwpAg4eqxBIviOn1C1KDt5qtGD4gozZT0dOoOz55hhgbLzTcAFEydN+cVLuFzDjAv0ylVcu85NCJHGDeYrZoQbwE0zQsMt+G6bENidu2i+Z2IPyn0PHjw0XiXe8gitoWQH5wUeq/sh8i9/8hR49jyJwF8AL1+9jtPyJvQWePc+2bfEP3xE66ewP9yGP1zXHAQ+f0naQJR+/aZph+rawPfk/UBp5Y+f3qYYjb/qf/8pE/NUM7I4Z+KmNfGIIB+KieiN3URBZ7AnCnpXhwRB/3KiFYxef9r5C2e9DqbJP1I0AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDI0LTAzLTI1VDIwOjQ3OjU1KzAwOjAw9L2zHwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyNC0wMy0yNVQyMDo0Nzo1NSswMDowMIXgC6MAAAAodEVYdGRhdGU6dGltZXN0YW1wADIwMjQtMDMtMjVUMjA6NDc6NTUrMDA6MDDS9Sp8AAAAAElFTkSuQmCC`
      const titleInterval = setInterval(() => {
        if (document.title === CONNECTION_ERROR_TAB_TITLE) {
          document.title = 'BrightTALK Talks'
        } else {
          document.title = CONNECTION_ERROR_TAB_TITLE
        }
      }, 2000)
    
      return () => clearInterval(titleInterval)
    }

    if (props.focused) {

      favico.href = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAIEUExURQAAAGbMAGbMAGbMAGbMAGbMAGbMAGbMAGbMAGbMAGbMAGbMAGbMAGXMAGTLAGPLAHjSHp3eW7Dle7PlgLPlf6XhaI7ZQ3PQFmXMAZHaSOT20v7//f////n99eL1z6zjdHHQFHzTJOb31vj99PD65/D65vP77Pv++dPwtnzTJqfibOL1zpLbSX3UJ4LVLpTbTL/qlfL76tfyvHXRG77pkqXhamLLAGbMA5DaRuj32Lnoi2fMAsHqmP3+/JjdVJPbS/T77e/65YHVLmjNBMXsnqrjcZrdV8fsoWfMAYfXOPf88tTxuGrNB4fXN5ndVv3++2jMBMTrnpLbSur43JfdVGbMAo7ZQuf31vz++6vjc/3//KThZ3XRGXjSHbrojPH6523ODfL76ev43ev43vr997XmhPv++MXsn3/UKv7//srtp6/kerHlfLDlfLLlftHws+j32ZXcTmbMAZfcVGHKAGrNBoLVL8LrmWnNB63kdvr99uP20HrTImnNCMLrmrbnhoPWMvH66OX21GrNCNPwt/n99IzZQLnoiqHgYsTrnZndVXDPEd70yPb874fXNpXcT970yXHQEnfSHdvzw////qHgY3zTJdDvsN30x9rzwYXWNHTRF4bXNub31ez534zZP4HVLez54Of31+T20Y/aRJzeW+754nvTJKzjdb7pk5jdU3rTIY+zEXgAAAAMdFJOUwADPqTl/Ahx5gL35OUEtOcAAAABYktHRBycBEEHAAAAB3RJTUUH6AMZFC4r4OaqSgAAAhNJREFUSMeVludbE0EQh5ckEMrunGCXX0QULNiCKIjmFBDFXlAIKkYEWxQbihgLdkEURcTeY9d/0vDEhNzxbLh5P8/73O7Mzs0IITJcbk+mnJBMj9uVIWJkebMnjo6T7c0SIseb6zReylxvjnB5nMdL6XEJNydeSrfI4wl5wpofRakYpMblSljjJ+UXTE4wpWDqtOkz7IpFUDNnFSIV3+yiOUovqOK5wLyS0gTzFwCFCxcprUBlwOIlS5MsW+4vB1ZUKO0XVgKrKkklIKNqdTWwZq1WCMBcZ1gOQOtrUFtHzgW5oR7YyBGMTSYaNjME2rIV27ZzhB1Mwdi5i3ek3XuAMsalqbEGey21tgv7KtUY1NQcRMt+faUDOHCw9VCS4ubQYZiBtnQCjrR3JKn1AUePtekf36hg5/iJk2mF8KnTnQnOnA2dKwHOX+hKI5gXL6W0qOq+3ONDaSMnrVciV3HtunIsSHWjF7jJqLSkW7dxp1U5F+Tde7j/gBhCrHHD+QZH6AP6OULXQ5gDDEE9eozBJ4w7GE99GHrmPEs0/BwjEV3h/MCL1H6I/ctfvgJeV2gEKgLevH03xvD7yAfg4yfdW6LPXzBSHg1G4wSjHYNh4Os3bQNJ+f2HrR1a2kM/9f0gZVPdL39vkp7fnX/+Vtnng3VkESnrpcfNLO5QlNyxK5mDPSawVodRgbOcxAWn689//gFny9ZxW9DzYgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyNC0wMy0yNVQyMDo0Njo0MyswMDowMLQF7YUAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjQtMDMtMjVUMjA6NDY6NDMrMDA6MDDFWFU5AAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAyMDI0LTAzLTI1VDIwOjQ2OjQzKzAwOjAwkk105gAAAABJRU5ErkJggg==`
      document.title = 'BrightTALK Talks'
    }
    
  }, [props.connectionStatus, props.focused])

  useInterval(() => {
    
    const seconds = differenceInSeconds(Date.now(), new Date(props.twilioConnectionError))
    if (secondsPassed < seconds) setSecondsPassed(seconds)
    
  }, 1000)
  
  if (props.twilioConnectionError === null) return null

  const onClick = () => {
    if (props.user) {
      const { firstName, lastName, externalIdV2} = props.user
      addEntry('PresenterService', 'ReconnectionModalButtonClicked', `${firstName} ${lastName} reconnection modal button clicked - user_id:${externalIdV2}`, 'info', externalIdV2)
    }
    props.reconnectRoom()
  }

  return <Modal
    isOpen={true}
    concise={true}
    hideBorder={true}
    dataBdd='reconnection-modal'
  >
    <Modal.Header dataBdd='reconnection-modal-header' >Connection lost</Modal.Header>
    <Modal.Body className={style['Reconnection-sidebyside']} >
      <Icon name={props.connectionStatus === 'reconnecting' ? IconType.iconName.spinner : IconType.iconName.danger} className={`${style[`Reconnection-spinner`]} ${style[`--centerContent`]}`} />
      <div style={{ padding: '5px' }} data-bdd='reconnection-modal-text' >
        <p>You lost your network connection. {props.connectionStatus === 'reconnecting' && 'Attempting to reconnect…'}</p>
      </div>
    </Modal.Body>
    <Modal.Footer className={style['--centerContent']}>
      {secondsPassed > 10 && <Button
        color={IconType.colour.link}
        text='Rejoin now'
        onClick={onClick}
        dataBdd='reconnection-button'
      />}
    </Modal.Footer>
  </Modal>

}

export default ReconnectionModal
